module.exports = __webpack_public_path__ + "static/media/marketing_tools.37d5d120.png";